import { aggregatedPageOffsets } from "~/feature/dashboard/pageOffsetHistory";
import { transformGetEventsAggregatedResponse } from "~/feature/dashboard/transformResponse";
import type {
  IGetEventsAggregatedRequestParams,
  IGetEventsAggregatedResponseBody,
  IGetMarketsByEventIdRequestParams,
  IGetMarketsByEventIdResponseBody,
} from "~/feature/dashboard/types";
import { api, ApiTagType } from "~/store/api";

const API_PREFIX = "/events";

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEventsAggregated: builder.query<
      IGetEventsAggregatedResponseBody,
      IGetEventsAggregatedRequestParams
    >({
      query: (params) => ({
        url: `${API_PREFIX}/aggregated`,
        params: aggregatedPageOffsets.withTrackedOffset(params),
      }),
      transformResponse: (
        response: IGetEventsAggregatedResponseBody
      ): IGetEventsAggregatedResponseBody => {
        return transformGetEventsAggregatedResponse(response);
      },
      onQueryStarted: async (params, { queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;
          aggregatedPageOffsets.recordResponse(params, data);
        } catch {
          // aborted/failed fetches record nothing; errors surface via the hook
        }
      },
      extraOptions: { latestOnly: true },
      providesTags: [ApiTagType.EventsAggregated],
    }),
    getMarketsByEventId: builder.query<
      IGetMarketsByEventIdResponseBody,
      IGetMarketsByEventIdRequestParams
    >({
      query: ({ id, ...params }) => ({
        url: `${API_PREFIX}/aggregated/${id}/markets`,
        params,
      }),
      providesTags: [ApiTagType.EventsAggregatedMarkets],
    }),
  }),
  overrideExisting: false,
});

export const { useGetEventsAggregatedQuery, useGetMarketsByEventIdQuery } =
  dashboardApi;
